const DAY_MS = 24 * 60 * 60 * 1000;

// Calendar-day distance between two YYYY-MM-DD strings (UTC math so DST
// transitions can never make the difference 23 or 25 hours).
const dayDiff = (a, b) =>
    Math.round((new Date(a + 'T00:00:00Z') - new Date(b + 'T00:00:00Z')) / DAY_MS);

export function parse_data(data) {
    // Group by the `date` column rather than the data_id prefix: the two can
    // disagree, and `date` is what the API window is actually filtered on.
    const uniqueDates = [...new Set(data.map(item => item.date.value))].sort();
    if (uniqueDates.length === 0) {
        return {0: [], 1: [], 2: []};
    }
    const newest = uniqueDates[uniqueDates.length - 1];

    // Buckets align with the day slider's labels: 2 = the most recent day in
    // the data, 1 = one calendar day back, 0 = two days back. Keying on the
    // calendar distance (not sorted position) means a missing middle day
    // leaves its own bucket empty instead of shifting older data up, and the
    // newest data always lands in bucket 2 — the dashboard's default view.
    let sorted_data = {0: [], 1: [], 2: []}

    uniqueDates.slice(-3).forEach(date => {
        const bucket = 2 - dayDiff(newest, date);
        if (bucket >= 0 && bucket <= 2) {
            const dayData = data.filter(item => item.date.value === date);
            sorted_data[bucket] = dayData.sort((a, b) => a.barn_num - b.barn_num);
        }
    });

    return sorted_data
}